const p2e = s => {
  return s?.replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
};

export default p2e;
